import * as S from "./Slider.style";

const SliderInfo = ({
  roundedDots = true,
  single = false,
  children,
  customPaging,
  ...props
}) => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    variableWidth: single,
  };

  if (customPaging) {
    settings["customPaging"] = customPaging;
  }

  return (
    <S.Slider {...settings} roundedDots={roundedDots} {...props}>
      {children}
    </S.Slider>
  );
};

export default SliderInfo;
